export default __webpack_public_path__ + "static/media/coresanscr55-webfont.8afafa1f.woff2";